<template>
    <transition name="fade">
        <div class="WebsiteDialogue" v-show="websiteDialogueVisible" @click="toggleWebsiteDialogue()">
            <div class="wd-container" @click="$event.stopPropagation()"><!--stopPropagation so toggleWebsiteDialogue() wont trigger on dialogue itself -->
                
                <!-- Toolbar -->
                <div class="wd-bar">
                    <input v-if="showURL" class="wd-bar-link" disabled="true" type="text" v-bind:value="this.url">
                    <div class="wd-bar-buttons">  
                        <md-button class="md-icon-button" @click="openLink()">
                            <OpenInNewIcon class="openInNewIcon"/>
                        </md-button>
                        <md-button class="md-icon-button" @click="toggleWebsiteDialogue()" style="margin-right: 0;">
                            <CloseIcon class="closeIcon"/>
                        </md-button>
                    </div> 
                </div>

                <!-- PDF -->
                <!-- <iframe class="wd-iframe" id="wd-iframe" v-show="type == 'pdf'" :src="url"/> -->
                <vue-pdf-embed class="wd-iframe" id="wd-pdf" v-show="type == 'pdf'" :source="url" :width="pdfWidth"/>
                
                <!-- Website -->
                <iframe class="wd-iframe" v-show="type == 'web'" :src="url" frameborder="0"/>

                <!-- Image -->
                <img class="wd-image wd-iframe" v-show="type == 'image'" :src="url" alt="">
            </div>         

        </div>  
    </transition>
</template>

<style>
    .WebsiteDialogue{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #000000d0;
        z-index: 5;
    }
    .wd-container{
        margin-top: 40px;
        position: absolute;
        background: white;
        border-radius: 10px;
        transition: width .4s ease, height .4s ease;
        overflow: hidden;
        width: 88%;
        height: 88%;
    }
    .wd-bar{
        padding: 3px;
        padding-right: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.774);
        display: flex;
        position: relative;
        z-index: 99;
    }
    .wd-bar-link {
        width: calc(90% - 92px);
        padding: 10px;
        border: .5px solid rgb(180, 180, 180);
        background: rgb(241, 241, 241);
        border-radius: 6px;
        font-size: 16px;
        font-family: var(--primaryFont), Helvetica, Arial, sans-serif;
        cursor: text;
    }
    .wd-bar-link::selection{
        color: rgb(238, 238, 238);
    }
    .wd-bar-link:focus {
        outline: none;          
    }
    .wd-bar-buttons{
        margin-left: auto;
    }

    /* Website */
    .WebsiteDialogue .wd-iframe{
        width: 100%;
        height: calc(100% - 46px);
        overflow-x: hidden;
        border-radius: 0px 0px 10px 10px;
    }

    /* PDF */
    .WebsiteDialogue .vue-pdf-embed > div{
        display: flex;
        justify-content: center;
    }
    .WebsiteDialogue .textLayer{
        display: none;
    }
    .WebsiteDialogue .annotationLayer{
        display: none;
    }

    /* Image */
    .wd-image{
        object-fit: contain;
    }

    /* Icons */
    .WebsiteDialogue .material-design-icon {
        height: 2.2em;
        width: 2.2em;
    }
    .WebsiteDialogue .material-design-icon > .material-design-icon__svg {
        fill: black !important;
        height: 2.2em;
        width: 2.2em;
    }
    .WebsiteDialogue .md-button{
        background: transparent;
        padding: 0;
        width: 30px;
    }

    /* Close Icon */
    .material-design-icon.closeIcon{
        height: 2.5em;
        width: 2.5em;
    }
    .material-design-icon.closeIcon > .material-design-icon__svg {
        fill: rgb(252, 113, 113) !important;
        height: 2.5em;
        width: 2.5em;
    }

    /* open in new Tab Icon */
    .material-design-icon.openInNewIcon {
        fill: black;
        height: 1.9em;
        width: 1.9em;
    }
    .material-design-icon.openInNewIcon > .material-design-icon__svg {
        height: 1.9em;
        width: 1.9em;
    }

    /* Mobile */
    @media (max-device-width: 900px){
        .wd-screen{
            z-index: 99;
        }
    }
</style>
    
<script>
import {mapMutations} from 'vuex';

import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

// Icons
import CloseIcon from 'vue-material-design-icons/Close.vue'
import OpenInNewIcon from 'vue-material-design-icons/OpenInNew.vue'

export default {
    components: {CloseIcon, OpenInNewIcon, VuePdfEmbed},
    inject: ['toggleCommunication'], 
    data: function () {
        return {
            websiteDialogueVisible: false,
            showURL: true, //Wether url at the top of the dialogue should be visible
            url: "",
            type: "web",
            pdfWidth: 1000
        }
    }, 
    watch: {
        type(){
            setTimeout(() => {
                if(this.type == "pdf")
                    this.pdfWidth = document.getElementById("wd-pdf").clientWidth;
                }, 0);
        }
    },
	methods: {
        ...mapMutations(["setDialogueOpen"]),

        // Toggles visibility of this dialogue
        toggleWebsiteDialogue(){
            this.websiteDialogueVisible=!this.websiteDialogueVisible;
            this.setDialogueOpen(this.websiteDialogueVisible);

            if(!this.websiteDialogueVisible){
                this.url = "";
                this.showURL = false;
                this.type = "web";
            }        
        },

        // Opens Link in separate window
        openLink(){
            window.open(this.url, '_blank');
        },

        // Displays this dialogue and changes url
        initDialogue: function(e) {
            this.url = e.detail.url; 
            this.showURL = e.detail.showURL;  

            if(this.url.includes('.jpg') || this.url.includes('.png') || this.url.includes('.webp'))
                this.type = "image";

            if(this.url.includes(".pdf")){
                this.type = "pdf";
                // this.url = this.url.replace("https://sales.flux-cms.de",".");

                // Google PDF Viewer
                // this.url = 'https://drive.google.com/viewerng/viewer?embedded=true&url='+this.url;

                // let timerId = setInterval(() => {
                //     document.getElementById("wd-iframe").src = document.getElementById("wd-iframe").src;
                // }, 1000);

                // document.getElementById("wd-iframe").addEventListener('load',() => {
                //     clearInterval(timerId);
                // });
            }

            this.toggleWebsiteDialogue();
        },
    },

    // Add Eventlistener that displays and initializes this dialogue. Event gets fired inside URLButton component
    mounted: function(){
        window.addEventListener('openURL',this.initDialogue);
    }
}

</script>